import StyledTextArea from './StyledTextArea';
export default StyledTextArea;
